<template>
  <div class="app-main-content" type="primary">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="2401"
          :reset="true"
          :custom-sim-query-placeholder="$t('Clearing.QuickRetrieval') + $t('SystemMaintenance.TemplateName')"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <!--查看-->
            <el-button no="look" :disabled="isEnable" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
            <!--编辑-->
            <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" no="Edit" :disabled="isEnable" type="success" @click="toEdit()">{{ $t('SeaExport.Edit') }}</el-button>
            <!--新增-->
            <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" no="new" type="primary" @click="toAdd()">{{ $t('common.btn.new') }}</el-button>
            <!--启用-->
            <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" no="enable" :disabled="isEnableDisabled" type="primary" @click="toEnable()">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
            <!--禁用-->
            <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" no="disable" :disabled="isDisableDisabled" type="danger" @click="toDisable()">{{ $t('CargoMsg.Cargo_Disable') }}</el-button>
            <!--删除-->
            <el-button v-if="$checkPermission(['button_DocumentTemplateManagement_edit'])" no="Delete" :disabled="isDeleteDisabled" type="danger" @click="toDelete()">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2400052"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="24000523"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
      <!-- 预览文件弹窗 -->
      <pre-view-file-dialog
        :v-if="previewFileData.visible"
        no="preview"
        :title="$t('FileHistory.preview')"
        :visible="previewFileData.visible"
        :file="previewFileData.file"
        :can-maximize="true"
        @close="closePreviewDialog"
      />
    </div>
  </div>
</template>

<script>
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch.vue'
import warehouseStatisticsWindow from '@/components/Cargo/Warehouse/components/warehousing/warehouseStatisticsWindow.vue'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow.vue'
import {
  batchDeleteDocumentTemplate,
  batchUpdateDocumentTemplateStatus,
  getDocumentTemplateList
} from '@/api/sysManage/documentTemplateManagement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import URL from '@/api/urlTranslator'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { FIELD_FILE_TYPE_ALL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getDocCategoryTypeTree } from '@/api/sysManage/baseConfig/docCategory'
import { sortByMultiField } from '@/utils'

const DEFAULT_PAGE_SIZE = 20

export default {
  name: 'DocumentTemplateTreeGrid',
  components: { preViewFileDialog, pictureViewWindow, warehouseStatisticsWindow, searchItem },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      gridApi: null,
      gridParams: {},
      pageCount: 0,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        conditions: [],
        total: 0,
        currentPage: 1,
        pageNum: 1,
        pageSize: 10
      },
      previewFileData: {
        visible: false,
        file: null
      },
      selectedData: null,
      loading: null,
      filterJson: {},
      rowData: [],
      selectedRows: [],
      customSearchItems: [],
      templateTypeTreeData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: (event) => {
          this.selectedData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        },
        onSelectionChanged: () => {
          this.selectedRows = this.gridApi ? this.gridApi.getSelectedRows() : []
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.toLookDouble(event.data)
        }
      },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SystemMaintenance.TemplateId'),
          field: 'documentId',
          colId: 'documentId',
          width: 200,
          cellRenderer: (params) => {
            if (params.data.documentId && params.value) {
              const documentId = params.data.documentId
              const fileName = params.data.fileName || params.value
              return `<a href="javascript:void(0)" onclick="document.querySelector('#document-template-tree-grid').__vue__.handlePreviewFile('${documentId}', '${fileName}')" style="color:#46a6ff">${documentId}</a>`
            }
            return params.value || ''
          }
        },
        {
          headerName: this.$t('SystemMaintenance.TemplateName'),
          field: 'templateName',
          colId: 'templateName',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.LocalizedTemplateName'),
          field: 'localTemplateName',
          colId: 'localTemplateName',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.TemplateStatus'),
          field: 'status',
          colId: 'status',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actionLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VersionNo'),
          field: 'version',
          colId: 'version',
          width: 100,
          cellRenderer: (params) => {
            return params.value === 0 ? '' : params.value
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          colId: 'dateModified',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SystemMaintenance.TemplateType'),
          field: 'templateType',
          colId: 'templateType',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.TemplateDescription'),
          field: 'templateDescription',
          colId: 'templateDescription',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.LocalizedTemplateDescription'),
          field: 'localTemplateDescription',
          colId: 'localTemplateDescription',
          width: 200
        },
        {
          headerName: this.$t('Message.FileSize'),
          field: 'fileSize',
          colId: 'fileSize',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 150,
          cellRenderer: params => {
            return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
          }
        }
      ]
    }
  },
  computed: {
    // 启用按钮是否禁用
    isEnableDisabled() {
      // 多选时不可用
      if (!this.selectedRows || this.selectedRows.length !== 1) {
        return true
      }
      // 已启用状态不可用
      const selectedRow = this.selectedRows[0]
      return selectedRow.status === SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
    },
    // 禁用按钮是否禁用
    isDisableDisabled() {
      // 多选时不可用
      if (!this.selectedRows || this.selectedRows.length !== 1) {
        return true
      }
      // 已禁用状态不可用
      const selectedRow = this.selectedRows[0]
      return selectedRow.status === SystemConstants.DOCUMENT_TEMPLATE_DISABLE.code
    },
    // 删除按钮是否禁用
    isDeleteDisabled() {
      // 多选时不可用
      if (!this.selectedRows || this.selectedRows.length !== 1) {
        return true
      }
      // 启用状态不可用
      const selectedRow = this.selectedRows[0]
      return selectedRow.status === SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code
    },
    // 查看和编辑按钮是否禁用
    isEnable() {
      return !this.selectedRows || this.selectedRows.length !== 1
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        await this.loadTemplateTypeTreeData()
        // 确保数据加载完成后再设置customSearchItems
        this.$nextTick(() => {
          this.customSearchItems = this.getCustomSearchItems()
        })
      }
    }
  },
  async mounted() {
    await this.loadTemplateTypeTreeData()
    // 确保数据加载完成后再设置customSearchItems
    this.$nextTick(() => {
      this.customSearchItems = this.getCustomSearchItems()
      this.toQuery()
    })
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'fileType'
      searchField.subType = 'cascader'
      searchField.fieldType = 'FIELD_FILE_TYPE_ALL'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'document.TEMPLATE_TYPE'
      searchField.itemLabel = 'SystemMaintenance.TemplateType'
      searchField.itemValue = ''
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dataProvider = this.templateTypeTreeData

      const formattedField = searchField.formatObj2Json()
      // 手动添加dataProvider，因为formatObj2Json会排除它
      formattedField.dataProvider = this.templateTypeTreeData
      defaultSearchFields.push(formattedField)
      return defaultSearchFields
    },
    async loadTemplateTypeTreeData() {
      const loading = getLoading4Cxt(this)
      let templateTypeTreeData = []
      await getDocCategoryTypeTree().then(res => {
        const sortedDetails = sortByMultiField(res.data, ['level', 'type', 'code', 'chineseName'], false)
        // 直接转换为CargoCascader格式，不需要中间的树形结构
        templateTypeTreeData = this.convertToCascaderFormat(sortedDetails)
        this.templateTypeTreeData = templateTypeTreeData
      }).finally(() => {
        loading.close()
      })
      return templateTypeTreeData
    },

    // 基于path将平铺数据转换为级联选择器格式
    convertToCascaderFormat(flatData) {
      const pathMap = {}
      const result = []

      // 深拷贝并去重处理 - 基于path去重
      const uniqueData = []
      const seenPaths = new Set()
      flatData.forEach(item => {
        // 深拷贝响应式对象，获取实际值
        const plainItem = {
          uuid: item.uuid,
          chineseName: item.chineseName,
          englishName: item.englishName,
          code: item.code,
          path: item.path,
          level: item.level
        }

        if (!seenPaths.has(plainItem.path)) {
          seenPaths.add(plainItem.path)
          uniqueData.push(plainItem)
        }
      })

      // 创建路径映射
      uniqueData.forEach(item => {
        pathMap[item.path] = {
          label: item.chineseName || item.englishName || item.code,
          value: item.path, // 使用完整path作为value
          children: []
        }
      })

      // 基于path构建层级关系
      uniqueData.forEach(item => {
        const node = pathMap[item.path]
        const pathParts = item.path.split(',')

        if (pathParts.length === 1) {
          // 第一级，作为根节点
          result.push(node)
        } else {
          // 多级，找到父节点path
          const parentPath = pathParts.slice(0, -1).join(',')
          const parentNode = pathMap[parentPath]

          if (parentNode) {
            // 找到父节点，添加到父节点的children中
            parentNode.children.push(node)
          } else {
            // 找不到父节点，可能是数据问题，作为根节点处理
            result.push(node)
          }
        }
      })

      // 清理空的children数组，确保只展示到第三级
      this.cleanEmptyChildren(result)
      return result
    },
    // 清理空的子节点数组，确保只展示到第三级
    cleanEmptyChildren(nodes) {
      nodes.forEach(node => {
        // 检查当前节点的层级（通过value中的逗号数量判断）
        const pathParts = node.value ? node.value.split(',') : []

        // 如果是第三级节点，清空子节点，使其成为叶子节点
        if (pathParts.length >= 3) {
          delete node.children
          node.leaf = true
        } else if (node.children && node.children.length > 0) {
          // 递归清理子节点
          this.cleanEmptyChildren(node.children)
        } else {
          // 如果没有子节点，删除children属性
          delete node.children
          node.leaf = true
        }
      })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      this.filter.jobNo = ''
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt()
      getDocumentTemplateList(this.filter).then((response) => this.handleQueryData(response)).finally(() => {
        this.loading.close()
      })
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.conditions = []
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt()
      getDocumentTemplateList(this.filter).then((response) => this.handleQueryData(response)).finally(() => {
        this.loading.close()
      })
    },

    handleQueryData(res) {
      this.rowData = res.data.list || []
      this.pageCount = res.data.pages || 0
      this.filter.currentPage = res.data.pageNum || 1
      this.filter.pageSize = res.data.pageSize || DEFAULT_PAGE_SIZE
      this.filter.total = Number(res.data.total) || 0
    },
    toAdd(row) {
      this.$emit('add', row || {})
    },
    toLookDouble(row) {
      row = this.selectedData || this.getRowData()
      this.$emit('look', row)
    },
    toLook(row) {
      const rows = this.readSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      row = this.selectedData || this.getRowData()
      this.$emit('look', row)
    },
    // 删除
    toDelete() {
      const rows = this.readSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const row = rows[0]
      this.$confirm(this.$t('SystemMaintenance.TemplateDeletedPrompt', [row.templateName, row.localTemplateName]), this.$t('CargoMsg.Cargo_OrderDelete'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_OrderDelete'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const ids = []
        for (const row of rows) {
          ids.push(row.uuid)
        }
        batchDeleteDocumentTemplate(ids).then(resp => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.toQuery()
        }).catch(() => {
          this.$message.error(this.$t('CargoMsg.Cargo_DeleteFailed'))
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        // 用户取消删除操作，不需要处理
      })
    },
    async toEdit() {
      const row = this.selectedData || this.getRowData()
      if (row == null) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      this.$emit('edit', row)
    },
    toEnable() {
      const rows = this.readSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const row = rows[0]
      this.$confirm(this.$t('SystemMaintenance.TemplateEnabledPrompt', [row.templateName, row.localTemplateName]), this.$t('CargoMsg.Cargo_Enable'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const ids = []
        for (const row of rows) {
          ids.push(row.uuid)
        }
        batchUpdateDocumentTemplateStatus({ uuids: ids, status: SystemConstants.DOCUMENT_TEMPLATE_ENABLE.code }).then(resp => {
          this.$message.success(this.$t('SystemMaintenance.EnabledSuccessfully'))
          this.toQuery()
        }).catch(() => {
        }).finally(() => this.loading.close())
      })
    },
    toDisable() {
      const rows = this.readSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const row = rows[0]
      this.$confirm(this.$t('SystemMaintenance.TemplateDisabledPrompt', [row.templateName, row.localTemplateName]), this.$t('CargoMsg.Cargo_Disable'), {
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonText: this.$t('CargoMsg.Cargo_Disable'),
        confirmButtonClass: 'el-button--danger',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const ids = []
        for (const row of rows) {
          ids.push(row.uuid)
        }
        batchUpdateDocumentTemplateStatus({ uuids: ids, status: SystemConstants.DOCUMENT_TEMPLATE_DISABLE.code }).then(resp => {
          this.$message.success(this.$t('SystemMaintenance.DisabledSuccessfully'))
          this.toQuery()
        }).catch(() => {
        }).finally(() => this.loading.close())
      })
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    refresh() {
      this.toQuery()
    },
    getRowData(row) {
      if (!row) {
        row = this.selectedData
      }
      if (!row) {
        const rows = this.readSelectedRows()
        if (rows && rows.length > 0) {
          row = rows[0]
        }
      }
      return row
    },
    // 获取勾选行
    readSelectedRows() {
      return this.gridApi.getSelectedRows()
    },
    updateListData(newData) {
      this.rowData = newData
      this.toQuery()
    },
    // 预览文件
    handlePreviewFile(documentId, fileName) {
      this.previewFileData.file = {
        fileId: documentId,
        fileName: fileName
      }
      this.previewFileData.visible = true
    }
  }
}
</script>

